import moment from "moment";
import { User } from "src/app/core/models/auth.models";
import { CompanyModel } from "src/app/core/models/company.model";
import { FileModel } from "./file.model";
import { RequestVersionModel, Status } from "./request-version.model";

export class ProjectRequestModel {
  public id: number;

  public name: string;
  public estimatedFinalDate: moment.Moment | null;
  public status: Status;

  public authorId: number | null;
  public customerId: number | null;
  public partnerId: number | null;

  public author: User | null;
  public customer: CompanyModel | null;
  public partner: CompanyModel | null;
  public country: string | null;
  public createdAt: string;
  public updatedAt: string;

  public versions: RequestVersionModel[];

  constructor($obj?: any) {
    this.id = $obj ? $obj.id : '#new' + moment().valueOf();
    this.name = $obj ? $obj.name : '';
    this.estimatedFinalDate = $obj ? moment($obj.estimatedFinalDate) : null;
    this.status = $obj ? $obj.status : Status.Draft;

    this.authorId = $obj && $obj.authorId ? $obj.authorId : $obj && $obj.author ? $obj.author.id : null;
    this.partnerId = $obj && $obj.partnerId ? $obj.partnerId : $obj && $obj.partner ? $obj.partner.id : null;
    this.customerId = $obj && $obj.customerId ? $obj.customerId : ($obj && $obj.customer) ? $obj.customer.id : null;
    this.country = $obj && $obj.country ? $obj.country : null;

    this.author = $obj && $obj.author ? new User($obj.author) : null;
    this.partner = $obj && $obj.partner ? new CompanyModel($obj.partner) : null;
    this.customer = $obj && $obj.customer ? new CompanyModel($obj.customer) : null;

    this.versions = $obj ? $obj.versions : [];

    this.createdAt = $obj ? $obj.createdAt : null;
    this.updatedAt = $obj ? $obj.updatedAt : null;
  }

  get canContract(): boolean { return this.status !== Status.Approved ? true : false; }

  setByForm(form: any) {
    this.country = form.country;
    this.name = form.name;
    this.customerId = form.customer !== '' ? parseInt(form.customer) : null;
    this.partnerId = form.partner !== '' ? parseInt(form.partner) : null;
    return this;
  }

  setVersionDropdown(): { list: any[], options: any[] } {
    const dropdown: { list: any[], options: any[] } = { list: [], options: [] };
    if (this.versions.length > 0) {
      this.versions.forEach(v => {
        if (dropdown.list.find((f: any) => f.id === v.id) === undefined) {
          dropdown.list.push(v);
          dropdown.options.push({ label: `V${v.version} ${moment(v.createdAt).format('YYYY-MM-DD')} (${v.status})`, value: v.id });
        }
      });
      dropdown.options = dropdown.options.sort((a, b) => parseInt(a.value) > parseInt(b.value) ? 1 : -1);
    }
    return dropdown;
  }

  toCreateAPI(version: RequestVersionModel) {
    if (version.needs) {
      return {
        name: this.name,
        description: version.description,
        targetUsers: version.targetUsers,
        availableBudget: version.availableBudget,
        startDate: version.startDate,
        estimatedFinalDate: version.estimatedFinalDate,
        proposalFinalDate: version.proposalFinalDate,
        currency: version.currency,
        version: version.version,
        partnerId: this.partnerId,
        customerId: this.customerId,
        country: this.country,
        needs: version.needs,
      };
    }
    return {
      name: this.name,
      description: version.description,
      targetUsers: version.targetUsers,
      availableBudget: version.availableBudget,
      startDate: version.startDate,
      estimatedFinalDate: version.estimatedFinalDate,
      proposalFinalDate: version.proposalFinalDate,
      currency: version.currency,
      version: version.version,
      partnerId: this.partnerId,
      customerId: this.customerId,
      country: this.country,
    };
  }

  toUpdateAPI() {
    return {
      name: this.name,
      customerId: this.customerId,
      partnerId: this.partnerId,
      country: this.country
    };
  }

}
